import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  PropertyImages,
  PropertyAssetTypes,
  FinancialOverview,
  FinancialIncome,
  FinancialCapitalDetails,
  FinancialCapitalGrowth,
  PropertyLocation,
  FloorPlanLayout,
  Timeline,
  Video,
  FinancialExpense,
  FinancialSummary
} from './property-details.model';
import {
  propertyImagesBuilderUI,
  propertyAssetTypesBuilderUI,
  propertyFinancialOverviewBuilderUI,
  propertyFinancialIncomeBuilderUI,
  propertyFinancialCapitalDetailsBuilderUI,
  propertyFinancialCapitalGrowthBuilderUI,
  propertyLocationBuilderUI,
  floorPlanLayoutBuilderUI,
  timelineBuilderUI,
  videoBuilderUI,
  propertyFinancialExpenseBuilderUI,
  propertyFinancialSummaryBuilderUI
} from './property-details.mapper';

import { PropertySummary } from './property-details.model';
import { propertySummaryBuilderUI } from './property-details.mapper';

@Injectable({
  providedIn: 'root'
})
export class PropertyDetailsService {
  baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  getPropertyAssetTypes(): Observable<Array<PropertyAssetTypes>> {
    return this._http
      .get(`${this.baseUrl}/properties/asset-types`)
      .pipe(map(propertyAssetTypesBuilderUI));
  }

  getPropertyImages(ids): Observable<PropertyImages> {
    return this._http
      .get(
        `${this.baseUrl}/properties/${ids.propertyId}/assets/${
          ids.propertyAssetTypeId
        }`
      )
      .pipe(map(propertyImagesBuilderUI));
  }

  getPropertySummary(id): Observable<PropertySummary> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/summary`)
      .pipe(map(propertySummaryBuilderUI));
  }

  getFinancialOverview(id): Observable<FinancialOverview> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/overview`)
      .pipe(map(propertyFinancialOverviewBuilderUI));
  }

  getFinancialIncome(id): Observable<FinancialIncome> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/income`)
      .pipe(map(propertyFinancialIncomeBuilderUI));
  }

  getFinancialExpense(id): Observable<FinancialExpense> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/expense`)
      .pipe(map(propertyFinancialExpenseBuilderUI));
  }

  getFinancialCapitalGrowth(id): Observable<Array<FinancialCapitalGrowth>> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/capitalgrowth`)
      .pipe(map(propertyFinancialCapitalGrowthBuilderUI));
  }

  getFinancialCapitalDetails(id): Observable<Array<FinancialCapitalDetails>> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/capitaldetail`)
      .pipe(map(propertyFinancialCapitalDetailsBuilderUI));
  }

  getFinancialSummary(id): Observable<FinancialSummary> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/financials/summary`)
      .pipe(map(propertyFinancialSummaryBuilderUI));
  }

  getPropertyLocation(id): Observable<PropertyLocation> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/location`)
      .pipe(map(propertyLocationBuilderUI));
  }

  getFloorPlanLayout(id): Observable<FloorPlanLayout> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/layout`)
      .pipe(map(floorPlanLayoutBuilderUI));
  }

  getTimelines(id): Observable<Array<Timeline>> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/timeline`)
      .pipe(map(timelineBuilderUI));
  }

  getVideo(id): Observable<Video> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/video`)
      .pipe(map(videoBuilderUI));
  }
}
